/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M12 10C10.8955 10 10 9.10457 10 8C10 6.89543 10.8955 6 12 6C13.1046 6 14 6.89543 14 8C14 9.10457 13.1046 10 12 10ZM12 10L12 17M12 17C14.7615 17 17 14.7614 17 12H15.125M12 17C9.23862 17 7.00004 14.7614 7.00004 12H8.87504"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M2 11.6C2 8.23968 2 6.55953 2.65396 5.27606C3.2292 4.14708 4.14709 3.2292 5.27606 2.65396C6.55953 2 8.23969 2 11.6 2H12.4C15.7603 2 17.4405 2 18.7239 2.65396C19.8529 3.2292 20.7708 4.14708 21.346 5.27606C22 6.55953 22 8.23968 22 11.6V12.4C22 15.7603 22 17.4405 21.346 18.7239C20.7708 19.8529 19.8529 20.7708 18.7239 21.346C17.4405 22 15.7603 22 12.4 22H11.6C8.23969 22 6.55953 22 5.27606 21.346C4.14709 20.7708 3.2292 19.8529 2.65396 18.7239C2 17.4405 2 15.7603 2 12.4V11.6Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M22 11.6C22 8.23969 22 6.55953 21.3461 5.27606C20.7708 4.14709 19.853 3.2292 18.724 2.65396C17.4405 2 15.7604 2 12.4 2L11.6 2C8.23973 2 6.55957 2 5.2761 2.65396C4.14713 3.2292 3.22925 4.14708 2.65401 5.27606C2.00005 6.55953 2.00005 8.23968 2.00005 11.6L2.00005 12.4C2.00004 15.7603 2.00004 17.4405 2.65401 18.7239C3.22925 19.8529 4.14713 20.7708 5.2761 21.346C6.55957 22 8.23973 22 11.6 22H12.4C15.7604 22 17.4405 22 18.724 21.346C19.853 20.7708 20.7708 19.8529 21.3461 18.7239C22 17.4405 22 15.7603 22 12.4V11.6ZM12 10C13.1046 10 14 9.10457 14 8C14 6.89543 13.1046 6 12 6C10.8955 6 10 6.89543 10 8C10 9.10457 10.8955 10 12 10Z"
				fill="currentColor"
			/>
			<path
				d="M12 10C10.8954 10 10 9.10457 10 8C10 6.89543 10.8954 6 12 6C13.1046 6 14 6.89543 14 8C14 9.10457 13.1046 10 12 10ZM12 10V17M12 17C14.7614 17 17 14.7614 17 12H15.125M12 17C9.23858 17 7 14.7614 7 12H8.875M11.6 22H12.4C15.7603 22 17.4405 22 18.7239 21.346C19.8529 20.7708 20.7708 19.8529 21.346 18.7239C22 17.4405 22 15.7603 22 12.4V11.6C22 8.23968 22 6.55953 21.346 5.27606C20.7708 4.14708 19.8529 3.2292 18.7239 2.65396C17.4405 2 15.7603 2 12.4 2H11.6C8.23969 2 6.55953 2 5.27606 2.65396C4.14709 3.2292 3.2292 4.14708 2.65396 5.27606C2 6.55953 2 8.23968 2 11.6V12.4C2 15.7603 2 17.4405 2.65396 18.7239C3.2292 19.8529 4.14709 20.7708 5.27606 21.346C6.55953 22 8.23969 22 11.6 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M10.85 1.25C7.48969 1.25 5.80953 1.25 4.52606 1.90396C3.39709 2.4792 2.47921 3.39708 1.90397 4.52606C1.25001 5.80953 1.25001 7.48968 1.25001 10.85L1.25001 13.15C1.25 16.5103 1.25 18.1905 1.90397 19.4739C2.47921 20.6029 3.39709 21.5208 4.52606 22.096C5.80953 22.75 7.48969 22.75 10.85 22.75L13.15 22.75C16.5103 22.75 18.1905 22.75 19.4739 22.096C20.6029 21.5208 21.5208 20.6029 22.096 19.4739C22.75 18.1905 22.75 16.5103 22.75 13.15L22.75 10.85C22.75 7.48969 22.75 5.80953 22.096 4.52606C21.5208 3.39709 20.6029 2.4792 19.4739 1.90396C18.1905 1.25 16.5103 1.25 13.15 1.25L10.85 1.25ZM10 7C10 5.89543 10.8954 5 12 5C13.1046 5 14 5.89543 14 7C14 7.84431 13.4768 8.56642 12.737 8.85984C12.7456 8.90526 12.7501 8.95213 12.7501 9.00005L12.7501 16.1841C14.4961 15.8732 15.8732 14.4961 16.1841 12.7501L15.1251 12.7501C14.7108 12.7501 14.3751 12.4143 14.3751 12.0001C14.3751 11.5858 14.7108 11.2501 15.1251 11.2501L17.0001 11.2501C17.4143 11.2501 17.7501 11.5858 17.7501 12.0001C17.7501 15.1757 15.1757 17.7501 12.0001 17.7501C8.82442 17.7501 6.25006 15.1757 6.25006 12.0001C6.25006 11.5858 6.58585 11.2501 7.00006 11.2501L8.87506 11.2501C9.28928 11.2501 9.62506 11.5858 9.62506 12.0001C9.62506 12.4143 9.28927 12.7501 8.87506 12.7501L7.81603 12.7501C8.12691 14.4961 9.50401 15.8732 11.2501 16.1841L11.2501 9.00005C11.2501 8.95215 11.2546 8.90529 11.2631 8.85988C10.5232 8.56649 10 7.84435 10 7Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M9.5 2L9 2V2C8.07116 2 7.60674 2 7.21685 2.05133C4.52445 2.40579 2.4058 4.52444 2.05134 7.21684C2.00001 7.60674 2.00001 8.07116 2.00001 9L2.00001 12.4C2.00001 15.7603 2.00001 17.4405 2.65397 18.7239C3.22921 19.8529 4.14709 20.7708 5.27606 21.346C6.55953 22 8.23969 22 11.6 22H12.4C15.7603 22 17.4405 22 18.7239 21.346C19.8529 20.7708 20.7708 19.8529 21.346 18.7239C22 17.4405 22 15.7603 22 12.4V9C22 8.07116 22 7.60674 21.9487 7.21684C21.5942 4.52444 19.4756 2.40579 16.7832 2.05133C16.3933 2 15.9288 2 15 2V2L14.5 2M12 10C10.8954 10 10 9.10457 10 8C10 6.89543 10.8954 6 12 6C13.1046 6 14 6.89543 14 8C14 9.10457 13.1046 10 12 10ZM12 10V17M12 17C14.7614 17 17 14.7614 17 12H15.125M12 17C9.23858 17 7.00001 14.7614 7.00001 12H8.875"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M12 10C10.8954 10 10 9.10457 10 8C10 6.89543 10.8954 6 12 6C13.1046 6 14 6.89543 14 8C14 9.10457 13.1046 10 12 10ZM12 10V17M12 17C14.7614 17 17 14.7614 17 12H15.125M12 17C9.23858 17 7.00001 14.7614 7.00001 12H8.875M11.6 22H12.4C15.7603 22 17.4405 22 18.7239 21.346C19.8529 20.7708 20.7708 19.8529 21.346 18.7239C22 17.4405 22 15.7603 22 12.4V11.6C22 8.23968 22 6.55953 21.346 5.27606C20.7708 4.14708 19.8529 3.2292 18.7239 2.65396C17.4405 2 15.7603 2 12.4 2H11.6C8.23969 2 6.55953 2 5.27606 2.65396C4.14709 3.2292 3.22921 4.14708 2.65397 5.27606C2.00001 6.55953 2.00001 8.23968 2.00001 11.6V12.4C2.00001 15.7603 2.00001 17.4405 2.65397 18.7239C3.22921 19.8529 4.14709 20.7708 5.27606 21.346C6.55953 22 8.23969 22 11.6 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M10.85 1.25C7.48969 1.25 5.80954 1.25 4.52606 1.90396C3.39709 2.4792 2.47921 3.39708 1.90397 4.52606C1.25001 5.80953 1.25001 7.48968 1.25001 10.85L1.25001 13.15C1.25001 16.5103 1.25001 18.1905 1.90397 19.4739C2.47921 20.6029 3.39709 21.5208 4.52606 22.096C5.80953 22.75 7.48969 22.75 10.85 22.75H13.15C16.5103 22.75 18.1905 22.75 19.4739 22.096C20.6029 21.5208 21.5208 20.6029 22.096 19.4739C22.75 18.1905 22.75 16.5103 22.75 13.15V10.85C22.75 7.48968 22.75 5.80953 22.096 4.52606C21.5208 3.39708 20.6029 2.4792 19.4739 1.90396C18.1905 1.25 16.5103 1.25 13.15 1.25L10.85 1.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12 5C10.8954 5 10 5.89543 10 7C10 7.84435 10.5232 8.56649 11.2631 8.85988C11.2546 8.90529 11.2501 8.95215 11.2501 9.00005L11.2501 16.1841C9.50401 15.8732 8.12692 14.4961 7.81603 12.7501L8.87506 12.7501C9.28928 12.7501 9.62506 12.4143 9.62506 12.0001C9.62506 11.5858 9.28928 11.2501 8.87506 11.2501L7.00007 11.2501C6.58585 11.2501 6.25007 11.5858 6.25007 12.0001C6.25006 15.1757 8.82443 17.7501 12.0001 17.7501C15.1757 17.7501 17.7501 15.1757 17.7501 12.0001C17.7501 11.5858 17.4143 11.2501 17.0001 11.2501L15.1251 11.2501C14.7108 11.2501 14.3751 11.5858 14.3751 12.0001C14.3751 12.4143 14.7108 12.7501 15.1251 12.7501L16.1841 12.7501C15.8732 14.4961 14.4961 15.8732 12.7501 16.1841L12.7501 9.00005C12.7501 8.95213 12.7456 8.90526 12.737 8.85984C13.4768 8.56642 14 7.84431 14 7C14 5.89543 13.1046 5 12 5Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
